import { RestSlice } from 'src/redux/rest.slice';
import { IppReportPackage } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippReviewsSlice = new RestSlice<IppReportPackage>(
	localizationService.getLocalizedString('ipp.reportPackage.package.reportPackageReviews'),
	Resource.IppReportPackages
);
export default ippReviewsSlice.rests.reducer;
